<template>
  <span class="image-box-tool">
    <template>
      <span v-hotkey="keymap" />
    </template>
    <button
      v-if="show"
      type="button"
      class="image-row__button"
      :class="{'image-row__button--disabled': disabled}"
      @click="action"
    >
      <div class="d-flex align-items-center">
        <base-icon
          :icon="icon"
          class="mr-2"
        />
        <div>{{ title }}</div>
      </div>

      <product-selector
        :show="addImageIsOpen"
        uploader
        title="Add image"
        location="create-collage"
        @cancel="hide"
        @complete="onSelectorComplete"
      />
    </button>
    <base-confirm-dialog
      v-if="confirmModal"
      message="You're off to a great start with your Collage!
      Adding this one will replace your work in progress. Are you sure you'd like to proceed?"
      positive-text="Confirm"
      @cancelled="confirmModal = false"
      @confirmed="confirm()"
    />
  </span>
</template>
<script>
import { fabric } from 'fabric';
import { sectionService, imageProcessingService } from '@/_services';

import { UPLOAD_MODE } from '@/components/ProductSelector';
import ImageBoxTool from './ImageBoxTool';

export default {
  name: 'AddImageImageBoxTool',
  extends: ImageBoxTool,
  props: {
    addImageIsOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      icon: 'images-row',
      title: 'Add Image',
      showSelector: false,

      hotkey: 'alt+i',

      confirmModal: false,
      product: null,
    };
  },
  computed: {
    keymap() {
      return {
        [this.hotkey]: this.action,
        esc: this.hide,
      };
    },
  },
  methods: {
    action() {
      this.$emit('update:addImageIsOpen', true);
    },
    hide() {
      this.$emit('update:addImageIsOpen', false);
    },
    confirm() {
      // Retrieve product content
      sectionService.fetchItemAsCollateral(this.product.pk).then((response) => {
        const canvasContent = response.data.canvas_content;
        this.$emit('canvas-added', canvasContent);
      }).catch((error) => {
        console.log(error);
        console.error('Unexpected error: Unable to retrieve section ', this.product.pk, 'as collateral');
      }).finally(() => {
        this.$emit('finished');
        this.product = null;
        this.confirmModal = false;
      });
      // const canvas_content = JSON.parse(this.product.canvas_content);
    },
    onSelectorComplete({ event, mode }) {
      const checkBlank = this.canvas.toJSON().objects.length;
      this.$emit('resetSelection');
      event.forEach((product, index) => {
        this.$emit('update:addImageIsOpen', false);
        // if (mode === UPLOAD_MODE.ALBUM) {
        if ([UPLOAD_MODE.ALBUM].includes(mode)) {
          if (product.shared) {
            this.product = product;
            if (checkBlank === 0) {
              this.confirm();
            } else {
              this.confirmModal = true;
            }
            // If user confirms, will fetch as collateral
            return;
          }
          // The image should be in our servers, so there is no need of reupload the file.
          console.log('Preventing upload', product.image);
          this.createImageFromURL(product.image, product, index);
          return;
        }
        if ([UPLOAD_MODE.FETCH, UPLOAD_MODE.UPLOAD, UPLOAD_MODE.CATALOG].includes(mode)) {
          // Store to S3
          imageProcessingService.uploadToS3(product.image_url, product).then((s3url) => {
            this.createImageFromURL(s3url, product, index);
          }).finally(() => {
            this.$emit('finished');
          });
        }
      });
    },
    /** Creates a Fabricjs Image */
    createImageFromURL(url, product, index) {
      console.log('Create image', index);
      // eslint-disable-next-line no-unused-vars
      const temp = new fabric.Image.fromURL(url, (image) => {
        console.log('Image created', index);
        if (image._element === null) {
          // eslint-disable-next-line
          new fabric.Image.fromURL(url, (image) => {
            this.prepareImage(image, index);
            console.log('imageAdded dispatched', index);
            this.$emit('imageAdded', image, product);
          }, { crossOrigin: 'Anonymous' });
        } else {
          this.prepareImage(image, index);
          console.log('imageAdded dispatched 2', image);
          this.$emit('imageAdded', image, product);
        }
      }, { crossOrigin: 'anonymous' });
    },
    /** Adds properties to the Fabricjs Image */
    prepareImage(image, index) {
      const checkBlank = this.canvas.toJSON().objects.length;
      const imageAspect = image.width / image.height;
      // eslint-disable-next-line no-unused-vars
      let gap = 0;
      image.lockUniScaling = true;
      image.setControlsVisibility({
        mt: false, // middle top disable
        mb: false, // midle bottom
        ml: false, // middle left
        mr: false, // I think you get it
      });

      const zoom = this.canvas.getZoom();

      if (imageAspect > 1.0) {
        // wide image
        image.scaleToWidth(0.3 * (this.canvas.width / zoom)); // size image
      } else {
        image.scaleToHeight(0.7 * (this.canvas.height / zoom));
      }
      // console.log(`Hey Felipe ${this.canvas.width} ${this.canvas.height} ${zoom}`);
      for (let i = 0; i < checkBlank; i++) {
        if ((i % 5 === 0)) {
          gap += i;
        }
      }
      image.set({
        originX: 'center',
        originY: 'center',
        /* This was the previous math to create an offset when adding multiple images
        but it  made the images appear in the top left corner. The math didn't make sense
        to me so I changed how the offset was calculated. If this causes an issue, revert. */

        // left:(this.canvas.width / (6 * zoom)) + (100 * index),
        // right: this.canvas.height / (7 * zoom) + ((index + gap) * 2)),
        left: this.canvas.width / 2 / zoom + index * 25,
        top: this.canvas.height / 2 / zoom + index * 25,
      });
    },
  },
};
</script>
